import React from 'react';
import { AlertCircle, XCircle } from 'lucide-react';
import { useAppSelector } from '../../store/hooks';

interface EventRejectionBannerProps {
  rejectionReason: string;
}

const EventRejectionBanner: React.FC<EventRejectionBannerProps> = ({ rejectionReason }) => {
  const { theme } = useAppSelector((state) => state.ui);

  return (
    <div className={`mx-3 sm:mx-4 md:mx-6 lg:mx-8 mb-4 sm:mb-6 rounded-xl shadow-lg border overflow-hidden backdrop-blur-sm ${
      theme === 'dark'
        ? 'bg-gradient-to-r from-red-900/40 via-red-800/30 to-red-900/40 border-red-700/50'
        : 'bg-gradient-to-r from-red-50 via-red-100/50 to-red-50 border-red-200'
    }`}>
      <div className="p-4 sm:p-5 md:p-6">
        <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
          {/* Icon */}
          <div className={`flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center ${
            theme === 'dark'
              ? 'bg-red-800/50 border-2 border-red-600/50'
              : 'bg-red-100 border-2 border-red-200'
          }`}>
            <XCircle className={`h-5 w-5 sm:h-6 sm:w-6 ${
              theme === 'dark' ? 'text-red-300' : 'text-red-600'
            }`} />
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0 w-full sm:w-auto">
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2 sm:mb-3">
              <h3 className={`text-base sm:text-lg font-bold ${
                theme === 'dark' ? 'text-red-200' : 'text-red-900'
              }`}>
                Event Rejected
              </h3>
              <div className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold w-fit ${
                theme === 'dark'
                  ? 'bg-red-800/50 text-red-200 border border-red-600/50'
                  : 'bg-red-200 text-red-800'
              }`}>
                <AlertCircle className="h-3 w-3 mr-1" />
                Rejected
              </div>
            </div>
            
            <div className={`mt-2 sm:mt-3 p-3 sm:p-4 rounded-lg ${
              theme === 'dark'
                ? 'bg-red-950/40 border border-red-800/50'
                : 'bg-white border border-red-200'
            }`}>
              <p className={`text-sm sm:text-base leading-relaxed break-words ${
                theme === 'dark' ? 'text-red-100' : 'text-red-800'
              }`}>
                <span className={`font-semibold block sm:inline ${
                  theme === 'dark' ? 'text-red-200' : 'text-red-900'
                }`}>
                  Rejection Reason:
                </span>
                <span className="block sm:inline sm:ml-2 mt-1 sm:mt-0">{rejectionReason}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventRejectionBanner;

